import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { Fragment, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../../hooks'
import { useDrawerStore } from '../../../hooks/useDrawerStore'
import { LocalStorageKey, RoutesMap } from '../../../types'
import { readLocalStorage, saveLocalStorage } from '../../../toolbox/helpers/local-storage-helpers'
import { icons, navSections } from '../../../toolbox/constants/NavSection'
import ScrollBar from '../Scrollbar/Scrollbar';
import { Role } from '../../../types/roles/roleTypes'
import { MODE_BUILDING_OWNER } from '../../../toolbox/defaults/app'
import { ListItemButtonStyle, ListItemIconStyle, ListMainItemButtonStyle } from '../../../styles/components/NavSection.styles'
import { useRenditionBuildingStore } from '../../../hooks/useRenditionBuildingStore'

export const NavSection = () => {
  //Hooks
  const { user } = useAuthStore()
  const { openDrawer } = useDrawerStore()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { setSelectedRenditionBuilding } = useRenditionBuildingStore();

  const initialRuta = readLocalStorage(LocalStorageKey.RUTA)
  const [ruta, setRuta] = useState(initialRuta || '')

  //   const routes = user?.modules || []
  const userRole: Role | any = user.userType;

  const validateUserType = (role: any) => {
    switch (role) {
      case Role.SUPER_ADMIN:
        return navSections.Superadmin;
      case Role.ADMIN:
        return MODE_BUILDING_OWNER === "building" ? navSections.AdminBuilding : navSections.Admin;
      case Role.TENANT:
        return navSections.Tenant;
      case Role.AGENT:
        return navSections.Agent;
      case Role.OWNER:
        return navSections.Owner;
    }
  }

  const routes: any = validateUserType(userRole);

  const isModule = (value: any): value is any => {
    return (value as any).name !== undefined
  }

  const handleOnClick = (value: any) => {
    if (isModule(value)) {
      if (ruta === value.name) {
        setRuta('')
      } else {
        saveLocalStorage(LocalStorageKey.RUTA, value.name)
        setRuta(value.name)
      }
    } else {
      openDrawer(false)
      //   navigate({ pathname: value.location })
    }
  }

  const handleItemSelected = (pathname: any) => {
    openDrawer(false)
    if (pathname === RoutesMap.RENDITION_ADMIN_BUILDING_OPEN) {
      setSelectedRenditionBuilding(undefined)
    }
    navigate({ pathname: pathname })
  }

  return (
    <ScrollBar sx={{ height: 1, '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' } }}>
      <List disablePadding sx={{ p: 1 }}>
        {
          !!(routes.length > 0) && routes.map((route, index) => {
            const isItemSelected = ruta === route.name
            const IconModule = route.icon
            return (
              <Fragment key={index}>

                <ListItemButton
                  sx={{
                    fontSize: 14,
                    fontFamily: 'Avenir Next Rounded Pro, sans-serif',
                    ...(isItemSelected ? {
                      color: 'rgb(18, 28, 76, 0.9)',
                      textTransform: 'uppercase',
                      bgColor: 'rgb(230, 247, 255)',
                      fontWeight: 'fontWeightBold',
                    } : null),
                    // ...ListMainItemButtonStyle,
                  }}
                  onClick={() => handleOnClick(route)}
                >
                  <ListItemIcon /* sx={ListItemIconStyle} */>
                    {IconModule != null ? IconModule : null}
                  </ListItemIcon>
                  <ListItemText disableTypography primary={route.name} />
                  {
                    isItemSelected ? (
                      <KeyboardArrowUpIcon />
                    ) : (
                      <KeyboardArrowDownIcon />
                    )
                  }
                </ListItemButton>

                {(
                  <Collapse in={isItemSelected} timeout="auto" unmountOnExit>
                    {route.rutas.map((view, index) => {
                      // if (view?.type == 1) {return}
                      const isSubRouteSelected = pathname === view.location
                      const Icon = view.icon
                      return (
                        <ListItemButton
                          onClick={() => handleItemSelected(view.location)}
                          key={index}
                          sx={{
                            // ...ListItemButtonStyle,
                            fontSize: 14,
                            ...(isSubRouteSelected ? {
                              // color: 'rgb(241, 90, 41)',
                              color: '#016088',
                              bgcolor: 'rgb(230, 247, 255)',
                              fontWeight: 'fontWeightBold',
                            } : null),
                          }}
                        >
                          <ListItemIcon /* sx={ListItemIconStyle} */>
                            {Icon != null ? Icon : null}
                          </ListItemIcon>
                          <ListItemText
                            disableTypography
                            primary={view.name_ruta}
                          />
                        </ListItemButton>
                      )
                    })}
                  </Collapse>
                )}
              </Fragment>
            )
          })
        }
      </List>
    </ScrollBar>
  )
}
